import React from 'react'
import PropTypes from 'prop-types'

import { Switch } from '@material-ui/core'

export default class BoolInput extends React.Component {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: undefined,
  }

  onChange = (e, checked) => {
    this.props.onChange(checked)
  }

  render() {
    const { value, onChange: _, ...rest } = this.props
    const v = (value === undefined) ? false : value
    return (
      <Switch
        checked={v}
        onChange={this.onChange}
        {...rest}
      />
    )
  }
}
